import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useHasTelcoCalculator() {
  const experiments = useExperiments()
  const marketplace = useMarketplace()

  return computed(
    () =>
      experiments['experiment.ppTelcoCalculator'] === 'withCalculator' &&
      marketplace.market.countryCode === MarketCountryCode.US,
  )
}
